import "../../../styles/flashcards/TopicLists.css";

import React, { useEffect, useState } from "react";
import {
  fetchLearningMapDetails,
  fetchTopicList,
} from "../../../services/DashboardApi";
import { useDispatch, useSelector } from "react-redux";

import { setSelectedTopic } from "../../../store/selectedTopicSlice";
import Loader from "../../atoms/Loader";
import { logger } from "../../../utils/logger";

const TopicLists = () => {
  const selectedMainTab = useSelector((state) => state.mainTab.tab_name);
  const [topics, setTopics] = useState([]);
  const { userId } = useSelector((state) => state.userDetails);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const selectedTopic = useSelector((state) => state.selectedTopic);

  useEffect(() => {
    const fetchData = async () => {
      //let userId = "1049";
      setIsLoading(true);
      let subject = selectedMainTab; // Use selectedMainTab as the subject
      try {
        const response = await fetchLearningMapDetails(userId, subject);
        response.data.unshift({ TOPIC_ID: "ALL", TOPIC_NAME: "All Topics" });
        setTopics(response.data);
        logger.log("Topics List from API: ", response.data);
      } catch (error) {
        logger.log("Error fetching topics: ", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedMainTab]);

  const handleTopicClick = (topicId, topicName) => {
    dispatch(setSelectedTopic({ topicId, topicName }));
  };

  return (
    <aside className="topicslist-sidebar">
      {isLoading ? (
        <Loader />
      ) : (
        topics?.map((data, i) => (
          <div
            onClick={() => handleTopicClick(data.TOPIC_ID, data.TOPIC_NAME)}
            className={`topicslist-sidebar-item ${
              selectedTopic.topicId === data.TOPIC_ID ? "active" : ""
            }`}
            key={i}
          >
            <div>
              <h4 style={{ paddingLeft: "10px" }}>{data.TOPIC_NAME}</h4>
            </div>
            <hr className="horizontal-line" />
          </div>
        ))
      )}
    </aside>
  );
};

export default TopicLists;
